import axios, { AxiosError, AxiosInstance } from 'axios';
import useAuthService from './auths/useAuthService';
import { getOrigin } from '../utils/urlUtils';

export const api: AxiosInstance = axios.create({
  baseURL: getOrigin(),
});

// Holds the latest token getter so the single request interceptor below always reads the
// CURRENT token instead of one frozen at render time. Kept fresh by useConfigureAxios on
// every render (including after a re-login), so requests like Print always use the new token.
let getAccessTokenRef: () => string = () => '';

// Registered once at module load — before any api call is made — so the interceptor never
// accumulates across renders/logins and no request can go out without it attached.
api.interceptors.request.use((config) => {
  const token = getAccessTokenRef();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(undefined, (error: AxiosError) => {
  const statusCode = error.response?.status;
  // 401s are expected on an expired session (the app already redirects to /login); don't noise the console.
  if (statusCode && statusCode !== 401) {
    console.error(error);
  }
  return Promise.reject(error);
});

export const useConfigureAxios = () => {
  const { getAccessToken } = useAuthService();
  // Point the interceptor's token getter at the latest auth state on every render.
  getAccessTokenRef = getAccessToken;
};
